import React from 'react';

interface Props {
  id?: string;
}

const VidaSectionHeader: React.FC<Props> = ({ id, children }) => (
  <React.Fragment>
    <h3 id={id}>{children}</h3>
    {/* language=CSS */}
    <style jsx>{`
      h3 {
        font-family: 'Volvo Novum', sans-serif;
        font-weight: 400;
        font-size: 20px;
        text-transform: uppercase;
        margin: 0;
      }
    `}</style>
  </React.Fragment>
);

export default VidaSectionHeader;
